import { ExternalContractType } from "../../slices/external-contract/Types";

export const externalContractSagaActionTypes = {
  callGetExternalContractSaga: "callGetExternalContractSaga",
  callAddExternalContractSaga: "callAddExternalContractSaga",
  callUpdateExternalContractSaga: "callUpdateExternalContractSaga",
  callDeleteExternalContractSaga: "callDeleteExternalContractSaga",
  callGetExternalContractDetailSaga: "callGetExternalContractDetailSaga",
  callGetWorkPackagesSaga: "callGetWorkPackagesSaga",
  callGetTypeOfEngagementsSaga: "callGetTypeOfEngagementsSaga",
};

export const getExternalContractSagaAction: (ID: number) => {
  type: string;
  payload: {
    ID: number;
  };
} = (ID: number) => {
  return {
    type: externalContractSagaActionTypes.callGetExternalContractSaga,
    payload: {
      ID: ID,
    },
  };
};

export type addExternalContractPayloadType = {
  externalContract: {
    company_name: string;
    salesforce_account: string;
    status: string;
    oracle_channel: number;
    country: string;
    region: string;
    so_number: number;
    salesforce_opportunity: string;
    type_of_engagement: string;
    revenue_stream: string;
    support_expiry_date: string | null;
    start_date: string;
    contract_name: string;
    contract_amount: string;
    collection: string;
    end_date: string;
    account_manager: string;
    sku: string;
  };
  ID: number;
};

export const addExternalContractSagaAction: (
  data: addExternalContractPayloadType
) => {
  type: string;
  payload: addExternalContractPayloadType;
} = (data: addExternalContractPayloadType) => {
  return {
    type: externalContractSagaActionTypes.callAddExternalContractSaga,
    payload: data,
  };
};

export const updateExternalContractSagaAction: (
  externalContract: ExternalContractType
) => {
  type: string;
  payload: {
    externalContract: ExternalContractType;
  };
} = (externalContract: ExternalContractType) => {
  return {
    type: externalContractSagaActionTypes.callUpdateExternalContractSaga,
    payload: {
      externalContract: externalContract,
    },
  };
};

export const deleteExternalContractSagaAction: (data: {
  externalContractID: number;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  type: string;
  payload: {
    data: {
      externalContractID: number;
      setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    };
  };
} = (data) => {
  return {
    type: externalContractSagaActionTypes.callDeleteExternalContractSaga,
    payload: {
      data: data,
    },
  };
};

export const getExternalContractDetailSagaAction: (ID: number) => {
  type: string;
  payload: {
    ID: number;
  };
} = (ID: number) => {
  return {
    type: externalContractSagaActionTypes.callGetExternalContractDetailSaga,
    payload: {
      ID: ID,
    },
  };
};

export const getWorkPackagesSagaAction: () => {
  type: string;
} = () => {
  return {
    type: externalContractSagaActionTypes.callGetWorkPackagesSaga,
  };
};

export const getTypeOfEngagementsSagaAction: () => {
  type: string;
} = () => {
  return {
    type: externalContractSagaActionTypes.callGetTypeOfEngagementsSaga,
  };
};
